import React from 'react'
import { useParams } from 'react-router-dom'
import { useState,useEffect } from 'react';
import ApiUrl from '../../../configTools/apiUrl';
import { Link } from 'react-router-dom';
import Title from '../../../components/forms/title'

const View = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [Order,setOrder] = useState(0);
    const {id} = useParams();
    useEffect(()=>{
        fetch(ApiUrl.API_URL_Orders+'/'+id,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                setOrder(data.responce);
            }
        });
    },[id,User])
  return (
    <div className='form_container'>
        <Title Name={Order !== 0 ? 'Order# '+Order.orderno: ''} BackURL = {null}/>
      {Order !== 0 &&
        <div className='admin_forms_row'>
            <div className='admin_col_60' style={{
                padding:"0px 20px 0px 0px"
            }}>
                <div className='admin_forms_container'>
                    <h1>Line Items</h1>
                    <div className='checkout_listings_items'>
                    {
                        Order.lineitems.map((item,index)=>{
                        return(
                            <div key={index} className='checkout_box_item'>
                            <div className='checkout_box_item_image'>
                                <div style={{
                                    width: "100%",
                                    paddingTop: "80%",
                                    borderRadius: "10px",
                                    position: "relative",
                                    backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.image})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center'
                                }}></div>
                            </div>
                            <div className='checkout_box_item_details'>
                                <Link to={"/product/"+item.slug}>
                                <h5>{item.title}</h5>
                                <p style={{fontSize:"12px", padding:"5px 0px"}}>{item.sku}</p>
                                </Link>
                                {item.hasvarients &&
                                <div className='checkout_box_item_details_container'>
                                    <div className='checkout_box_item_details_item'>
                                    <p>Size:</p>
                                    <p>{item.sizeName}</p>
                                    </div>
                                    <div className='checkout_box_item_details_item'>
                                    <p>Color:</p>
                                    <div style={{backgroundColor:item.colorcode}} className={"checkout_box_item_details_item_colorcode"}></div>
                                    </div>
                                </div>
                                }
                            </div>
                            <div className='checkout_box_item_price'>
                                <p>{"Rs."+item.price+"/-"}</p>
                            </div>
                            </div>
                        )
                        })
                    }
                    </div>
                </div>
            </div>
            <div className='admin_col_40'>
                {Order.user !== 0 &&
                    <div className='admin_forms_container'>
                        <h1>Buyer</h1>
                        <div className='checkout_details_user_admin_container' style={{margin:"0",padding:"20px 10px",backgroundColor:"white"}}>
                            <div className='checkout_details_user_image'>
                                <div style={{
                                    width: "100%",
                                    paddingTop: "80%",
                                    borderRadius: "10px",
                                    position: "relative",
                                    backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+Order.userdetails.image})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center'
                                }}>
                                </div>
                            </div>
                            <div className='checkout_details_user_details'>
                                <h3>{Order.userdetails.firstname+" "+Order.userdetails.lastname}</h3>
                                <h4>{"@"+Order.userdetails.username}</h4>
                            </div>
                        </div>
                    </div>

                }
                <div className='admin_forms_container'>
                    <h1>Seller</h1>
                    <div className='checkout_details_user_admin_container' style={{margin:"0",padding:"20px 10px",backgroundColor:"white"}}>
                        <div className='checkout_details_user_image'>
                            <div style={{
                                width: "100%",
                                paddingTop: "80%",
                                borderRadius: "10px",
                                position: "relative",
                                backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+Order.sellerdetails.image})`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center'
                            }}>
                            </div>
                        </div>
                        <div className='checkout_details_user_details'>
                            <h3>{Order.sellerdetails.firstname+" "+Order.sellerdetails.lastname}</h3>
                            <h4>{"@"+Order.sellerdetails.username}</h4>
                        </div>
                    </div>
                </div>
                <div className='admin_forms_container' style={{
                    marginTop:"10px"
                }}>
                    <h1>Status</h1>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Fulfilment</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.fulfilmentstatus===0?"Unfulfilled":"Fulfilled"}</p></div>
                    </div>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Payment</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.paymentstatus===0?"Unpaid":"Paid"}</p></div>
                    </div>
                </div>
                <div className='admin_forms_container' style={{
                    marginTop:"10px"
                }}>
                    <h1>Delivery</h1>
                    <div className='order_details_deliver_item'>
                        <h3>Name</h3>
                        <p>{Order.name}</p>
                    </div>
                    <div className='order_details_deliver_item'>
                        <h3>Email</h3>
                        <p>{Order.email}</p>
                    </div>
                    <div className='order_details_deliver_item'>
                        <h3>Contact</h3>
                        <p>{Order.contact}</p>
                    </div>
                    <div className='order_details_deliver_item'>
                        <h3>Address</h3>
                        <p>{Order.address}</p>
                    </div>
                    <div className='order_details_deliver_item'>
                        <h3>Location</h3>
                        <p>{Order.locationValue}</p>
                    </div>
                </div>
                <div className='admin_forms_container' style={{
                    marginTop:"10px"
                }}>
                    <h1>Value</h1>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Net Total</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.total}</p></div>
                    </div>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Shipping</h4></div>
                        <div className='order_details_value_item_dis'><p>
                            {
                                Order.shippingcost
                            }</p></div>
                    </div>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Grand Total</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.gtotal}</p></div>
                    </div>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Seller Shipping</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.sellershipping}</p></div>
                    </div>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Commission</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.commission}</p></div>
                    </div>
                    <div className='order_details_value_item'>
                        <div className='order_details_value_item_dis'><h4>Seller Payables</h4></div>
                        <div className='order_details_value_item_dis'><p>{Order.sellerpayables}</p></div>
                    </div>
                </div>
            </div>
        </div>
      }
    </div>
  )
}

export default View
